module.exports = __webpack_public_path__ + "img/title.9a7c552b.png";